import { Component, ContentChild, TemplateRef, input } from '@angular/core';
import { IconNameType } from '../icons/icon-name-type.enum';
import { IconComponent } from '../icons/icon.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'cwo-icon-label-value',
  standalone: true,
  imports: [IconComponent, CommonModule],
  templateUrl: './icon-label-value.component.html',
  styleUrl: './icon-label-value.component.scss'
})
export class IconLabelValueComponent {
  iconName = input.required<IconNameType>();
  iconSize = input<string>();
  label = input.required<string>();
  value = input<string>();
  
  @ContentChild('valueRef') valueRef?: TemplateRef<any>;
}
